<template>
  <div class="">
    <register-breakdown></register-breakdown>
  </div>
</template>

<script>
import RegisterBreakdown from "@/components/profile/companies-products/insurance-risks/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    RegisterBreakdown,
  },
  created() {
    this.notifyQueue({
      text: "Prodotti",
      path: "module.PROF",
      tab: "#InsurerRisks",
      level: 3,
    });
    this.notifyQueue({
      text: "Inserisci Prodotto",
      path: "insurance_risks.create",
      level: 4,
    });
  },
};
</script>
